import { createFileRoute } from '@tanstack/react-router'
import { ViewingsAgendaPage } from '../../../components/viewings/ViewingsAgendaPage'

/** The viewings agenda (spec 2026-10-25-12). The view, the date and the highlighted viewing live in the URL. */
export const Route = createFileRoute('/$org/rental-applications/viewings')({
  component: ViewingsAgendaPage,
  validateSearch: (search: Record<string, unknown>) => ({
    view: search.view === 'day' || search.view === 'week' ? (search.view as 'day' | 'week') : undefined,
    date: typeof search.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(search.date) ? search.date : undefined,
    viewing: search.viewing ? String(search.viewing) : undefined,
  }),
})
